export const login = (user) => {
    return (dispatch) => {
        dispatch({
            type: "LOGIN_SUCCESS",
            user: user
        });
    }
}
export const logout = () => {
    return (dispatch) => {
        dispatch({
            type: "LOGOUT",
            user: {}
        });
    }
}
export const editRounds = (rounds, structure, adminId) => {
    return (dispatch) => {
        dispatch({
            type: "editRounds",
            rounds: rounds,
            structure: structure,
            adminId: adminId
        })
    }
}

export const getStream = (data) => {
    return (dispatch) => {
        dispatch({
            type: 'GET_STREAM_SUCCESS',
            data: data
        });
    }
}

export const setIsLoading = (data) => {
    return (dispatch) => {
        dispatch({
            type: 'setIsLoading',
            data: data
        });
    }
}